
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BgAvatarUploader from "@/components/bg-avatar-uploader/index.vue";
import { Form } from "element-ui";
import {
  distinguishOcrBusinessLicense,
  getEnum,
} from "@/service/supplier-meta/api";
import { StepForm } from "../../common/StepForm";
import { genCacheMixin } from "../../common/cache.mixin";
import { getFieldLengthLimit } from "@/service/supplier-meta/common/supplier-field-ctrl";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { Enum } from "@/service/supplier-meta/entity/Enum";
function EnumToOption(enums: Enum[]): SelectOption[] {
  return enums.map((e) => ({
    label: e.desc,
    value: e.code,
  }));
}
@Component({
  components: {
    BgAvatarUploader,
  },
  mixins: [
    genCacheMixin({
      field: "form",
      saveKey: "SupplierBusinessLicense",
      useCache: (ctx: SupplierBusinessLicense) =>
        !(ctx.data && typeof ctx.data === "object"),
    }),
  ],
})
export default class SupplierBusinessLicense extends StepForm {
  form = {
    enterpriseInfo: {
      businessLicensePath: "",
      operator: "",
      businessNo: "",
      orgCode: "",
      companyType: null,
      managementStatus: null,
    },
    name: "",
  };
  errMsg = "";
  recognizeSuccess = false;
  companyTypeOptions: SelectOption[] = [];
  statusOptions: SelectOption[] = [];
  get rules(): { [x: string]: any[] } {
    return this.getFieldsRules([
      "enterpriseInfo.businessLicensePath",
      "enterpriseInfo.operator",
      "enterpriseInfo.businessNo",
      "enterpriseInfo.orgCode",
      "name",
      "enterpriseInfo.companyType",
      "enterpriseInfo.managementStatus",
    ]);
  }
  get lenLimit() {
    return getFieldLengthLimit(this.sourceType);
  }
  created() {
    this.getEnums();
    super.created();
  }
  async getEnums() {
    getEnum("CompanyTypeEnum", true).then((res) =>
      res.isSuccess ? (this.companyTypeOptions = EnumToOption(res.result)) : []
    );
    getEnum("ManagementStatusEnum", true).then((res) =>
      res.isSuccess ? (this.statusOptions = EnumToOption(res.result)) : []
    );
  }
  async validate() {
    const form = this.$refs.form as Form;
    const valid = await form.validate().catch(() => false);
    return valid;
  }
  getFormRef(): Form {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
    };
  }
  async handleBusinessNoChange(val: string) {
    const lenLimit = this.lenLimit;
    const businessNoLen = lenLimit["enterpriseInfo.businessNo"];
    const orgCodeLen = lenLimit["enterpriseInfo.orgCode"];
    if (val.length === businessNoLen) {
      this.form.enterpriseInfo.orgCode = val.slice(
        businessNoLen - orgCodeLen - 1,
        businessNoLen - 1
      );
    }
  }
  async handleBusinessLicensePathChange(val: string): Promise<void> {
    console.log(val);
    const form = this.getFormRef();
    form.validateField("enterpriseInfo.businessLicensePath");
    const res = await distinguishOcrBusinessLicense({
      image_url: val,
    });
    console.log(res);
    this.errMsg = "";
    if (res.is_success) {
      this.form.name = res.result?.name || "";
      this.form.enterpriseInfo.operator = res.result?.person || "";
      this.form.enterpriseInfo.businessNo = res.result?.reg_num || "";
      this.recognizeSuccess = true;
      const form = this.getFormRef();
      // 识别后进行“查重”校验
      form.validateField("name");
      form.validateField("enterpriseInfo.businessNo");
      this.handleBusinessNoChange(this.form.enterpriseInfo.businessNo);
      form.validateField("enterpriseInfo.orgCode");
    } else {
      this.recognizeSuccess = false;
      this.form.name = "";
      this.form.enterpriseInfo.operator = "";
      this.form.enterpriseInfo.businessNo = "";
      this.errMsg = res.error_info?.msg || "营业执照识别请求失败！";
    }
  }
}
